if (!customElements.get("before-after")) {
	customElements.define(
		"before-after",
		class BeforeAfter extends HTMLElement {
			constructor() {
				super();

				this.before = this.querySelector(".before");
				this.after = this.querySelector(".after");
				this.cursor = this.querySelector(".before-after__cursor");
				this.isDragging = false;

				this.handleMove = this.handleMove.bind(this);
				this.handleDown = this.handleDown.bind(this);
				this.handleUp = this.handleUp.bind(this);
			}

			connectedCallback() {
				this.addEventListener("mousedown", this.handleDown);
				this.addEventListener("touchstart", this.handleDown);
				window.addEventListener("mouseup", this.handleUp);
				window.addEventListener("touchend", this.handleUp);

				const observer = new IntersectionObserver(
					(entries, observer) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								this.animateCursor();
								observer.unobserve(this);
							}
						});
					},
					{ threshold: 0.5 }
				);

				observer.observe(this);
			}

			animateCursor() {
				const rect = this.getBoundingClientRect();
				const initialPos = rect.width / 2;

				this.before.style.width = initialPos + "px";
				this.cursor.style.left =
					initialPos - this.cursor.offsetWidth / 2 + "px";

				this.before.animate(
					[
						{ width: initialPos + "px" },
						{ width: initialPos - 50 + "px" },
						{ width: initialPos + "px" },
						{ width: initialPos + 50 + "px" },
						{ width: initialPos + "px" },
					],
					{
						duration: 2000,
						easing: "ease",
					}
				);

				this.cursor.animate(
					[
						{ left: initialPos - this.cursor.offsetWidth / 2 + "px" },
						{ left: initialPos - this.cursor.offsetWidth / 2 - 50 + "px" },
						{ left: initialPos - this.cursor.offsetWidth / 2 + "px" },
						{ left: initialPos - this.cursor.offsetWidth / 2 + 50 + "px" },
						{ left: initialPos - this.cursor.offsetWidth / 2 + "px" },
					],
					{
						duration: 2000,
						easing: "ease",
					}
				);
			}

			handleDown(e) {
				this.isDragging = true;
				e.preventDefault();
				this.addEventListener("mousemove", this.handleMove);
				this.addEventListener("touchmove", this.handleMove, { passive: false });
			}

			handleMove(e) {
				if (!this.isDragging) return;
				e.preventDefault();

				let clientX;
				if (e.touches) {
					clientX = e.touches[0].clientX;
				} else {
					clientX = e.clientX;
				}

				const rect = this.getBoundingClientRect();
				let pos = clientX - rect.left;
				if (pos < 0) pos = 0;
				if (pos > rect.width) pos = rect.width;

				this.before.style.width = pos + "px";
				this.cursor.style.left = pos - this.cursor.offsetWidth / 2 + "px";
			}

			handleUp() {
				this.isDragging = false;
				this.removeEventListener("mousemove", this.handleMove);
				this.removeEventListener("touchmove", this.handleMove);
			}
		}
	);
}
